import {fromJS} from 'immutable';

export const DEFAULT_STATE = fromJS({});

export default (state = DEFAULT_STATE) => {
    return state;
};
